import { FC, memo } from 'react'

import { CountdownEventProps } from '@/types/componentsPropsTypes'

import { CounterElem, Divider, VideoCountdownWrapper } from './styles'
import { useCountdown } from './useCountdown'

const CounterNodeRaw: FC<{ value: string }> = ({ value }) => {
  return <CounterElem>{value}</CounterElem>
}

const CounterNode = memo(CounterNodeRaw)

export const VideoOverlayCountdown: FC<CountdownEventProps> = ({
  startTime,
}) => {
  const remainingTime = useCountdown(startTime) || null

  const days = String(remainingTime?.days).padStart(2, '0')
  const hours = String(remainingTime?.hours).padStart(2, '0')
  const minutes = String(remainingTime?.minutes).padStart(2, '0')
  const seconds = String(remainingTime?.seconds).padStart(2, '0')

  return (
    <VideoCountdownWrapper $hidden={!remainingTime}>
      <CounterNode value={`${days}`} />
      <Divider>:</Divider>
      <CounterNode value={hours} />
      <Divider>:</Divider>
      <CounterNode value={minutes} />
      <Divider>:</Divider>
      <CounterNode value={seconds} />
    </VideoCountdownWrapper>
  )
}
